import {type ToastMessage} from 'primereact/toast';

export const NotificationsMarkedAllAsReadMessage: ToastMessage = {
    severity: 'success',
    summary: 'Processed',
    detail: 'Notifications successfully marked all as read',
};
